import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import CreateEvidenceForm from "../Forms/CreateEvidenceForm";
import { EvidenceFormData } from "../evidence.types";

interface CreateEvidenceModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  includeCaseField?: boolean;
  navigateToItem?: boolean;
  defaultFormData?: EvidenceFormData;
}

export const CreateEvidenceModal: FC<CreateEvidenceModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  includeCaseField = false,
  navigateToItem = false,
  defaultFormData,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <>
      <Modal open={show} onClose={onClose}>
        <CreateEvidenceForm
          width={700}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          includeCaseField={includeCaseField}
          navigateToItem={navigateToItem}
          defaultFormData={defaultFormData}
        />
      </Modal>
    </>
  );
};
